import React, { useState } from "react";
import { authFetch } from "../../../utils/authFetch";

// Token de 5 dígitos (10000-99999), generado del lado del front.
function generarTokenDeCincoDigitos() {
  return String(Math.floor(10000 + Math.random() * 90000));
}

const GenerarTokenButton = ({ email }) => {
  const [enviando, setEnviando] = useState(false);
  const [tokenGenerado, setTokenGenerado] = useState(null);
  const [error, setError] = useState(null);
  const [copiado, setCopiado] = useState(false);

  const handleGenerarToken = async () => {
    setEnviando(true);
    setError(null);
    setTokenGenerado(null);
    setCopiado(false);

    try {
      const token = generarTokenDeCincoDigitos();
      const url = `https://api.micrositec.com/api/token?email=${encodeURIComponent(
        email,
      )}&token=${encodeURIComponent(token)}`;

      const respuesta = await authFetch(url);
      const data = await respuesta.json();

      if (respuesta.ok && data.ok) {
        setTokenGenerado(token);
      } else {
        setError(data.message || "No se pudo generar el token");
      }
    } catch (err) {
      console.error("Error al generar token:", err);
      setError("Error de red al generar el token.");
    }

    setEnviando(false);
  };

  const handleCopiar = async () => {
    try {
      await navigator.clipboard.writeText(tokenGenerado);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch (err) {
      console.error("Error al copiar al portapapeles:", err);
    }
  };

  const handleCerrar = () => {
    setTokenGenerado(null);
    setError(null);
    setCopiado(false);
  };

  return (
    <div className="text-center">
      <button className="btn btn-outline-primary" onClick={handleGenerarToken} disabled={enviando}>
        {enviando ? "Generando..." : "Generar token"}
      </button>

      {error && <div className="alert alert-danger mt-2">❌ {error}</div>}

      {tokenGenerado && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content text-center">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Token generado</h5>
              </div>
              <div className="modal-body">
                <p className="mb-2">Token</p>
                <div
                  className="d-inline-block bg-primary bg-opacity-10 border border-primary rounded-3 px-4 py-2 fs-3 fw-bold text-primary"
                  style={{ letterSpacing: "2px" }}
                >
                  {tokenGenerado}
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                <button className="btn btn-outline-primary" onClick={handleCopiar}>
                  {copiado ? "¡Copiado!" : "Copiar al portapapeles"}
                </button>
                <button className="btn btn-secondary" onClick={handleCerrar}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GenerarTokenButton;
